export const isKnowledgeTool = (tool) => {
  const name = String(tool?.name || '').toLowerCase();

  return Boolean(tool?.configuration?.dataset_id) && (
    name.endsWith('_knowledge') ||
    name === 'knowledge'
  );
};
